// extracted by mini-css-extract-plugin
module.exports = {"button":"Categories_button__v0LKb","info":"Categories_info__1Akr9"};